export function path(){
	// return "http://toy.wxq.com";//本地
	// return "http://10.53.129.204:8083/ga_test/ga_api/public/index.php"//测试
	return "https://yrbh.lskyo.com/api/public/index.php"//正式
	// return "http://192.168.50.228/toy/public/index.php"//正式
}

export function down_path(){
	// return "/GA/public/static/";//本地
	// return "/ga_test/ga_api/public/static/excel/";//测试
	return "/ga/ga_api/public/static/excel/";//正式
}